import { appTimeHasMock, appTimeStore, getMockedNow } from '../../store/appTimeStore';

/** Flutter `appNow()` — mocked instant in dev when enabled. */
export const appNow = (): Date => getMockedNow() ?? new Date();

/** Flutter `appNowMs()`. */
export const appNowMs = (): number => appNow().getTime();

export const appTodayLocal = (): Date => {
  const now = appNow();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate());
};

export const isAppTimeMocked = (): boolean => appTimeHasMock(appTimeStore);
